import {
  CreateOrganizationPayload,
  UpdateOrganizationPayload,
} from "@/types/organization";

export const getAllOrganizations = async (): Promise<any[]> => {
  const response = await fetch("/api/v1/organizations?limit=500", {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  if (!response.ok) throw new Error("Failed to get all organizations");
  const result = await response.json();
  const items = result?.data?.items;
  return Array.isArray(items) ? items : [];
};

export const getAllowedOrganizations = async (): Promise<any[]> => {
  const response = await fetch("/api/v1/organizations/allowed?limit=500", {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  if (!response.ok) throw new Error("Failed to get allowed organizations");
  const result = await response.json();
  const items = result?.data?.items;
  return Array.isArray(items) ? items : [];
};

export const getOrganizationById = async (organizationId: string): Promise<any> => {
  const filters = encodeURIComponent(JSON.stringify([["name", "=", organizationId]]));
  const response = await fetch(
    `/api/v1/organizations?filters=${filters}&limit=1`,
    {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }
  );
  if (!response.ok) throw new Error("Failed to get organization by id");
  const result = await response.json();
  const items = result?.data?.items;
  return Array.isArray(items) && items.length > 0 ? items[0] : null;
};

export const createOrganization = async (
  organizationData: CreateOrganizationPayload
): Promise<any> => {
  const response = await fetch("/api/v1/organizations", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(organizationData),
  });
  if (!response.ok) throw new Error("Failed to create organization");
  const result = await response.json();
  return result?.data?.item ?? result?.data ?? result;
};

export const updateOrganization = async (
  organizationId: string,
  organizationData: UpdateOrganizationPayload
): Promise<any> => {
  const response = await fetch("/api/v1/organizations/update", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name: organizationId, ...organizationData }),
  });
  if (!response.ok) {
    const errorText = await response.text();
    let errorMessage = "Failed to update organization";
    try {
      const errorData = JSON.parse(errorText);
      errorMessage = errorData.message || errorData.error || errorMessage;
    } catch {
      errorMessage = errorText || errorMessage;
    }
    throw new Error(errorMessage);
  }
  const result = await response.json();
  return result?.data?.item ?? result?.data ?? result;
};

export const deleteOrganization = async (organizationId: string): Promise<any> => {
  const response = await fetch("/api/v1/organizations/delete", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name: organizationId }),
  });
  if (!response.ok) throw new Error("Failed to delete organization");
  const result = await response.json();
  return result?.data ?? result;
};
